import {Component, OnInit, ChangeDetectionStrategy, output} from '@angular/core';

@Component({
  selector: 'app-device-toolbar',
  templateUrl: './device-toolbar.component.html',
  styleUrls: ['./device-toolbar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceToolbarComponent implements OnInit {

  public readonly openCodeEditor = output<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix -- renaming the output would change every binding to it
  public readonly onPageSizeChange = output<any>();
  public viewportSize: any;
  public pageSizeTemplate = [
    {
      icon: 'fa-television',
      name: 'desktop',
      is_active: false,
      page_class: 'col-12 full-page'
    },
    {
      icon: 'fa-tablet',
      name: 'tablet',
      is_active: false,
      page_class: 'col-9 tablet'
    },
    {
      icon: 'fa-mobile',
      name: 'mobile',
      is_active: false,
      page_class: 'col-6 mobile'
    }
  ];

  constructor() {
  }

  ngOnInit(): void {
    this.onPageSizeSelect(this.pageSizeTemplate[0]);
  }

  onPageSizeSelect(item) {
    for (const pageSize of this.pageSizeTemplate) {
      pageSize.is_active = (item.name === pageSize.name);
    }
    this.viewportSize = item.name;
    this.onPageSizeChange.emit(this.viewportSize);
  }

  onEditHtml() {
    this.openCodeEditor.emit(true);
  }

}
